import { render, staticRenderFns } from "./knittedfabric.vue?vue&type=template&id=eab0dea4&scoped=true"
import script from "./knittedfabric.vue?vue&type=script&lang=js"
export * from "./knittedfabric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eab0dea4",
  null
  
)

export default component.exports